import { Acl, IOrganisationJson } from "shared";

export interface AuthContext<IOrganisation extends IOrganisationJson = IOrganisationJson> {
  _id: string;
  civility?: "Madame" | "Monsieur";
  nom: string;
  prenom: string;
  email: string;
  telephone: string;
  organisation_id: string;
  account_status: "PENDING_EMAIL_VALIDATION" | "PENDING_ADMIN_VALIDATION" | "CONFIRMED";
  has_accept_cgu_version: string;
  organisation: IOrganisation;

  // legacy field used for ERPs
  username: string;

  organisation_role?: "admin" | "member";

  // nom de l'organisme, enrichi au runtime depuis la collection organismes (CFA uniquement)
  organisation_nom?: string;

  // only admins can impersonate organisations
  impersonating?: boolean;

  acl: Acl;
}

// contexte côté UI

export const getUserOrganismeId = (user: AuthContext | null | undefined): string | undefined =>
  user?.organisation?.type === "ORGANISME_FORMATION" ? (user.organisation.organisme_id ?? undefined) : undefined;
